/**
 * @file
 * Capitaine study widget iframe resizer.
 *
 * @see web/themes/igs/components/blocks/widgets/capitainestudy.scss
 */

(function (Drupal, $) {
  Drupal.behaviors.capitaineStudyIframeResizer = {
    attach: (context, settings) => {
      // Make sure we don't add the event listeners more than once.
      if (window && window.capitaineStudyIframeResizerInitialized) {
        return;
      }

      window.capitaineStudyIframeResizerInitialized = true;

      const debounce = (func, delay) => {
        let timeoutId;

        return function(...args) {
          clearTimeout(timeoutId);

          timeoutId = setTimeout(() => {
            func.apply(this, args);
          }, delay);
        };
      };

      const handleResize = () => {
        const iframe = document.querySelector('iframe[src*="capitainestudy"]');

        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({ type: "resize" }, iframe.src);
        }
      };

      window.addEventListener('resize', debounce(handleResize, 250));

      window.addEventListener('message', (event) => {
        const allowedOrigins = [
          'https://staging-wwwcapitainestudyfr.kinsta.cloud',
          'https://www.capitainestudy.fr'
        ];

        if (!allowedOrigins.includes(event.origin)) {
          return;
        }

        const message = event.data;

        if (message && message.frameHeight) {
          const iframe = document.querySelector(`iframe[src*="${new URL(event.origin).hostname}"]`);

          if (iframe) {
            iframe.style.height = message.frameHeight + "px";
          }
        }
      });
    }
  };
})(Drupal, jQuery);
